;; This Source Code Form is subject to the terms of the Mozilla Public
;; License, v. 2.0. If a copy of the MPL was not distributed with this
;; file, You can obtain one at http://mozilla.org/MPL/2.0/

(ns renolit-roofing-service.shared.domain.types
  (:require [clojure.set]
            [malli.core :as m]))

(def wp-hierarchy
  {:visual-inspection
   {:from-below
    #{:sheet-and-patterns
      :fastening-arrangement
      :drains-and-downspouts
      :water-entry
      :other-pathologies}
    :installation
    #{:main-field-area
      :roof-edges-and-corners
      :fixing-and-adhesive
      :drainage-system
      :roof-penetrations
      :plant-and-technical-protection
      :alkorplan-solar-application
      :other-items}
    :condition-of-the-cover
    #{:accumulation-of-water
      :blisters
      :superficial-cracks
      :folds-wrinkles
      :shrinkage
      :quality-of-the-welding
      :repairs-completed
      :surface-contamination
      :other-damages-or-pathologies}}
   :non-destructive-testing
   {:nil #{:hd-photographic-samples
           ;; :thermography
           :eld}}
   :destructive-testing
   {:nil #{:physical-samples-of-sheet
           :sample-cover-package-tastings}}})

(def observations-hierarchy
  {:installation
   #{:fitted-field-sheets
     :main-field-area
     :metallic-unions
     :fastening-centers
     :supports
     :weld-width
     :exits
     :channels
     :seam-sealer
     :straps-for-the-glutes
     :deck-straps
     :corner-patches
     :penetrations
     :finished
     :plant
     :sacrificial-layer
     :baseboards
     :alkordesign
     :alkorsolar
     :debris
     :damage
     :next-operations
     :other-articles}
   :condition-of-the-cover
   #{:accumulation-of-water
     :blisters
     :surface-cracks
     :folds-or-wrinkles
     :shrinkage
     :welding-quality
     :previously-performed-repairs
     :surface-contamination
     :other-damages}})

(defn wp-task-types
  [wp-keys]
  (into #{}
        (comp
         (mapcat #(vals (get wp-hierarchy %)))
         cat)
        wp-keys))

(def ^:const service-status-pipeline
  "Ordered sequence of `:service-status` values, in the order a
  service progresses through them."
  [:review-pending :field-visit :laboratory :finalization-phase :diagnosis-closed])

(def ^:const enum-types
  "Set of custom enum types defined in the data application model,
  that need to be mapped to and from SQL enums.

  For example, we may have a \"user type\" attribute for the \"user\"
  domain entity. That attribute is named `:user-type` in the domain
  entity model, and the possible values are the set
  `#{:admin :plant-manager :asset-manager}`. In the SQL database we
  would define an enum type as:

    CREATE TYPE user_type AS ENUM ('admin', 'plant-manager', 'asset-manager');

  and in this map we would add the key `:user-type` with the value
  `#{:admin :plant-manager :asset-manager}`"
  {:user-role #{:rae
                :installer
                :laboratory}
   :service-origin #{:new-lead :warranty-alarm :window-alarm :scheduled}
   :service-reason #{:photovoltaic-solar-system-installation
                     :roof-refurbishment-renovation
                     :energy-efficiency-upgrade
                     :building-purchase-sale-asset-valuation
                     :technical-risk-assessment
                     :water-ingress-leaks
                     :impact-of-objects-on-roof
                     :damage-by-third-party-works
                     :damage-during-maintenance-works
                     :fire
                     :severe-weather-event
                     :rooftop-structures-technical-equipment-installation
                     :insurance-company-request
                     :design-team-consultant-surveyor-requirement
                     :periodic-inspection
                     :other}
   :customer-profile #{:building-owner :installer :prescriber :real-estate}
   :revision-type #{:general :focused}
   :wp #{:visual-inspection :destructive-testing :non-destructive-testing}
   :wp-type #{:from-below :installation :condition-of-the-cover :nil}
   :dirt-types #{:sand
                 :chemistry
                 :biological-bio
                 :water
                 :shadow
                 :others}
   :photo-position #{:vertical :horizontal}
   :face #{:n :s :e :w}
   :task-type (wp-task-types [:visual-inspection :non-destructive-testing :destructive-testing])
   :incidence-level #{:action-required :monitoring :information}
   :observation (into #{} cat (vals observations-hierarchy))
   :service-status (set service-status-pipeline)
   :notification-trigger #{:project-registered
                           :service-requested
                           :samples-taken
                           :samples-analyzed}
   :notification-audience #{:rae :installer :laboratory}
   :notification-type #{:event}
   :notification-agent #{:websocket}
   :notification-status #{:sent :not-sent}})

; :installer-submitted :laboratory-submitted

(defn get-type-schema
  [type-name]
  (m/schema
   [:and
    [:keyword]
    (apply conj [:enum] (get enum-types type-name))]))

(defn get-dropdown-values
  ([type-name]
   (get-dropdown-values type-name (get enum-types type-name [])))
  ([type-name ids]
   (let [ns (str "domain.choices." (name type-name))]
     (mapv (fn [id]
             {:id id
              :label-transl-kw (keyword ns (name id))})
           (or ids [])))))
